import { safeParseNullDefault, safeParse } from 'shouldve-been-js';

class SystemInfo {

    private _systemName: string | null;
    private _apiVersion: string | null;
    private _isOffice: boolean;

    public constructor(systemName: string | null, apiVersion: string | null, isOffice: boolean) {

        this._systemName = systemName;
        this._apiVersion = apiVersion;
        this._isOffice = isOffice;
    }

    public get systemName(): string | null {
        return this._systemName;
    }

    public set systemName(value: string | null) {
        this._systemName = value;
    }

    public get apiVersion(): string | null {
        return this._apiVersion;
    }

    public set apiVersion(value: string | null) {
        this._apiVersion = value;
    }

    public get isOffice(): boolean {
        return this._isOffice;
    }

    public set isOffice(value: boolean) {
        this._isOffice = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): SystemInfo {

        const systemInfo: string | null = safeParseNullDefault<string>(json?.systemName, '');
        const apiVersion: string | null = safeParseNullDefault<string>(json?.apiVersion, '');
        const isOffice: boolean = safeParse<boolean>(json?.isOffice, false);

        return new SystemInfo(systemInfo, apiVersion, isOffice);
    }
}

export default SystemInfo;